import { LoaderFunctionArgs, redirect } from 'react-router';
import { authService } from '~/services/auth/auth-service';
import { createRoutes } from '~/shared/models/create-routes';

export const signInPageLoader =
  () =>
  async ({ params }: LoaderFunctionArgs) => {
    await authService.initialized;

    if (!authService.isSignedIn) {
      return null;
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { redirect_url } = params;

    if (redirect_url) {
      return redirect(redirect_url);
    }

    return redirect(createRoutes.Base);
  };
